import { Identifiable, Event } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleMoveListElement(
  event: Identifiable<Event>,
): Identifiable<Event> {
  return event;
}

export { handleMoveListElement };
